import { useEffect, useState } from "react"
import { Html5Qrcode } from "html5-qrcode"
import { Modal, Button } from "react-bootstrap"
import toast from "react-hot-toast"
import { confirmQRCode } from "components/Apis/warehouse"
import { modifySkids } from "components/Apis/skids"
import { set } from "react-hook-form"

const InventoryScanner = ({ order }) => {
    const [showScanner, setShowScanner] = useState(false)
    const [showSkidCountConfirmationModal, setShowSkidCountConfirmationModal] = useState(false)

    const [scanner, setScanner] = useState(null)
    const [QRCode, setQRCode] = useState(null)
    const [skidCount, setSkidCount] = useState(order.skids.unloaded_count)

    const [messageModal, setMessageModal] = useState({
        show: false,
        message: "",
        type: "info", // can be "info", "success", "error"
    })

    async function initializeScanner() {
        const scannerConfig = {
            qrbox: { width: 300, height: 300 },
            rememberLastUsedCamera: true,
            fps: 4,
        }
        
        try {
            Html5Qrcode.getCameras()
                .then((devices) => {
                    if (!devices || devices.length === 0) {
                        toast.error("No cameras found. Please connect a camera and try again.")
                        return
                    }
                    else if (devices.length === 1) {
                        const scanner = new Html5Qrcode("reader")
                        setScanner(scanner)
                        scanner.start(
                            devices[0].id,
                            scannerConfig,
                            (decodedText, decodedResults) => {
                                setQRCode(decodedText.trim())
                            },
                            (errorMessage) => {
                                console.log("error using scanner: ", errorMessage)
                            }
                        )
                    }
                    else if (devices.length > 1) {
                        // ask user to select camera
                        const scanner = new Html5Qrcode("reader")
                        setScanner(scanner)
                        scanner.start(
                            devices[1].id,
                            scannerConfig,
                            (decodedText, decodedResults) => {
                                setQRCode(decodedText.trim())
                            },
                            (errorMessage) => {
                                console.log("error using scanner: ", errorMessage)
                            }
                        )
                    }
                })
        } catch (error) {
            toast.error("error with scanner: ", error)
        }
    }

    const stopScanner = () => {
        if (scanner) {
            scanner
                .stop()
                .then(() => {
                    setScanner(null)
                })
                .catch((error) => {
                    console.error("Error while stopping scanner: ", error)
                })
        }
    }

    useEffect(() => {
        if (showScanner) {
            initializeScanner()
        } else {
            setShowScanner(false)
            stopScanner()
        }
    }, [showScanner])

    useEffect(() => {
        const confirmScan = async () => {
            if (!QRCode) return
            confirmQRCode(order.id, QRCode)
                .then((response) => {
                    if (response.status) {
                        setShowScanner(false);
                        setShowSkidCountConfirmationModal(true);
                    }
                })
                .catch((error) => {
                    setShowScanner(false);
                    setMessageModal({
                        show: true,
                        message: error.response?.data?.msg || "Failed to confirm QR code.",
                        type: "error",
                    });
                    toast.error("Failed to confirm QR code.");
                });
        };

        confirmScan();
        setQRCode(null); // Reset QRCode after processing

    }, [QRCode]); // Runs when QRCode changes


    const handleConfirm = async () => {
        modifySkids(
            {
                order_id: order.id,
                loaded_count: skidCount,
            }
        )
        setShowSkidCountConfirmationModal(false)
        setShowScanner(false)
    }

    const handleCancel = () => {
        setShowScanner(false)
        setShowSkidCountConfirmationModal(false)
    }

    return (
        <>
            <button
                className='btn btn-primary m-1 px-2 py-1'
                onClick={(e) => setShowScanner(true)}
                title='Scan QR'
            >
                <i className='fa fa-qrcode' />
            </button>
            <Modal
                className="warehouse-modal"
                show={messageModal.show}
                onHide={() => setMessageModal({ ...messageModal, show: false })}
            >
                <Modal.Header closeButton>
                    <Modal.Title>{messageModal.type === "error" ? "Error" : "Info"}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className={`alert-${messageModal.type}`}>
                        {messageModal.message}
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => setMessageModal({ ...messageModal,
                        show: false })}>
                        Close
                    </Button>
                </Modal.Footer>
            </Modal>
            <Modal className="warehouse-modal" show={showScanner}>
                <>
                    <div id='reader'></div>
                    <div className='result-message text-center fw-bold'>Scan Order {order.order_no} QR Code</div>
                    <Button onClick={() => setShowScanner(false)}>Close</Button>
                </>
            </Modal>
            <Modal className="warehouse-modal" show={showSkidCountConfirmationModal}>
                <>
                    <Modal.Header>
                        <Modal.Title>
                            Confirm that order {order.order_no} has {order.units} units
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <table className='table'>
                            <thead style={{ fontWeight: "bold" }}>
                                <tr>
                                    <th>Order Number</th>
                                    <th>Units</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr key={order.id}>
                                    <td>{order.order_no}</td>
                                    <td>
                                        <input
                                            defaultValue={
                                                Number.isInteger(order.skids[0]?.loaded_count)
                                                    ? `${order.skids[0]?.loaded_count}`
                                                    : null
                                            }
                                            placeholder="Enter Observed Skid Count"
                                            className="input small thin"
                                            onChange={(e) =>
                                                setSkidCount(e.target.value)
                                            }
                                        />
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button onClick={handleCancel}>Close</Button>
                        <Button onClick={handleConfirm}>Confirm</Button>
                    </Modal.Footer>
                </>
            </Modal>
        </>
    )
}

export default InventoryScanner
